import * as React from 'react';
import Drawer from '../../Drawer';
import {UseDrawerReturn} from './types';
import {DrawerProps} from '../../types';

/**
 * The use drawer hook.
 * @param {Omit<DrawerProps, 'children'>} props
 * @return {UseDrawerReturn}
 */
export default function useDrawer(
    props: Omit<DrawerProps, 'children'>,
): UseDrawerReturn {
  const [
    isVisible, setVisible,
  ] = React.useState<boolean>(false);

  /**
   * Open the drawer.
   */
  function open(): void {
    setVisible(true);
  }

  /**
   * Close the drawer.
   */
  function close(): void {
    setVisible(false);
  }

  /**
   * Render the drawer.
   * @return {React.ComponentElement<DrawerProps, any> | undefined}
   */
  function render(
      node:
        | React.ReactNode
        | React.ReactNodeArray,
  ): React.ComponentElement<DrawerProps, any> | undefined {
    /**
     * The handle blur.
     */
    function handleBlur(): void {
      close();
    }

    return isVisible ? (
      <Drawer
        align={props.align}
        onBlur={handleBlur}
      >
        {node}
      </Drawer>
    ) : undefined;
  }

  return {
    isVisible,
    open,
    close,
    render,
  };
}
